import React, { useContext, useEffect } from "react";
import { AppContext } from "../States/AppContext";
import { Link } from "react-router-dom";

//styles
import { WaveImg } from "./PrimaryWave.elements";
import VideoPlayer from "../Common/VideoPlayer";

// images
import annotate1test from "../../img/waveforms/annotate/annotate1test.mp4";
import annotate2test from "../../img/waveforms/annotate/annotate2test.mp4";
import masterrelearnTEST from "../../img/waveforms/annotate/masterrelearn-copyTEST.mp4";
import alarmWave from "../../img/waveforms/alarms/alarml2.mp4";
import plethflat from "../../img/waveforms/pleth-flat4.mp4";

const PrimaryWave = () => {
  const { state, setState } = useContext(AppContext);

  const primary = state.waveData.filter((wav) => wav.primary === true);

  useEffect(() => {
    if (state.annotate2Img === true && state.annotate === false) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          annotate2Img: false,
          annotateOrRelearn: false,
          // annotate2Img: true,
        }));
      }, 3200);

      return () => clearTimeout(timeoutId);
    }
  }, [state.annotate2Img]);

  function replaceImg() {
    setState((prevState) => ({
      ...prevState,
      annotate2Img: true,
      masterRelearn: false,
      relearn: false,
    }));
  }

  function changeWave() {
    if (state.annotate) {
      setState((prevState) => ({
        ...prevState,
        annotate1Img: false,
        annotate2Img: true,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        annotate1Img: false,
        annotate2Img: false,
        masterRelearn: false,
        relearn: false,
        annotateOrRelearn: false,
      }));
    }
  }

  return (
    <>
      <Link
        to="/settings/changewave"
        style={{ gridArea: "wave1", position: "relative", background: "black" }}
      >
        {/* {(state.annotate || state.masterRelearn || state.annotate2Img) && (
          <div
            style={{
              position: "absolute",
              top: "0",
              width: "100%",
              height: "100%",
              background: "white",
              opacity: ".2",
            }}
          ></div>
        )} */}

        {state.annotateOrRelearn && (
          <div
            style={{
              position: "absolute",
              top: "0",
              width: "100%",
              height: "100%",
              background: "white",
              opacity: ".2",
            }}
          ></div>
        )}

        <div
          key={primary.name}
          style={{ display: "grid", placeItems: "center" }}
        >
          {state.ecgOffWave1 === true ? (
            <VideoPlayer
              src={annotate1test}
              ecgOff={true}
            />
          ) : state.initiateAlarms ? (
            <VideoPlayer
              src={alarmWave}
              loop={true}
            />
          ) : state.annotate1Img ? (
            <VideoPlayer
              src={annotate1test}
              onEnded={changeWave}
            />
          ) : state.annotate2Img ? (
            <VideoPlayer
              src={annotate2test}
              loop={true}
            />
          ) : state.masterRelearn ? (
            <VideoPlayer
              src={masterrelearnTEST}
              onEnded={replaceImg}
            />
          ) : primary[0].name === "Pleth" && !state.spoContinuous ? (
            <VideoPlayer
              src={plethflat}
              loop={true}
            />
          ) : (
            <VideoPlayer
              src={primary[0].vid}
              loop={true}
            />
          )}
        </div>
      </Link>
    </>
  );
};

export default PrimaryWave;
